<template>
  <v-dialog
    v-model="value"
    transition="dialog-top-transition"
    max-width="600px"
  >
    <v-card>
      <v-toolbar
        color="primary"
        dark
        dense
      >{{hdrText}} свойства </v-toolbar>
      <comp-property-card :property="localProperty" :mode="'editor'" @onPropUpdate="doPropUpdate"/>
      <v-card-actions>
        <v-btn class="secondary" @click="doClose">
          Закрыть
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn class="primary" dark :disabled="saveDisabled" @click="doSave" outlined>
          {{btnText}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CompPropertyCard from '@/components/modules/projects/cards/configuration/compPropertyCard'
import axios from 'axios'
import { UI_SNACKBAR } from '@/store/actions/ui'
export default {
  name: 'prjAddComponentPropertyDialog',
  components: { CompPropertyCard },
  props: ['property', 'component', 'value'],
  data () {
    return {
      localProperty: null
    }
  },
  computed: {
    btnText: {
      get () {
        return this.localProperty ? this.dataNew ? 'Добавить' : 'Обновить' : ''
      }
    },
    hdrText: {
      get () {
        return this.localProperty ? this.dataNew ? 'Добавление' : 'Редактирование' : ''
      }
    },
    saveDisabled: {
      get: function () {
        if (!this.localProperty) return true
        if (!this.component || !this.component.length) return true
        const noPropValue = !this.localProperty.CURR_PROP_VALUE
        return noPropValue || !this.dataChanged
      }
    },
    dataChanged: {
      get () {
        if (this.dataNew) return true
        return this.property[0].PROP_ID !== this.localProperty.PROP_ID || this.property[0].CURR_PROP_VALUE !== this.localProperty.CURR_PROP_VALUE
      }
    },
    dataNew: {
      get: function () {
        console.log('Requested for dataNew. Initial property is ', this.property, '. Local property is ', this.localProperty)
        return !this.property.length
      }
    }
  },
  watch: {
    property (val) {
      console.log('prjAddComponentPropertyDialog watcher property detected change to ', val)
      if (val && val.length) {
        console.log('val length is more than 0')
        // eslint-disable-next-line no-undef
        this.localProperty = structuredClone(this.property[0])
      } else {
        console.log('val length is 0')
        this.localProperty = {}
      }
      console.log('Current lP is ', this.localProperty)
    }
  },
  methods: {
    doSave () {
      const self = this
      const action = this.dataNew ? 'add' : 'update'
      const processorPath = action === 'update' ? '/api/org/receptures/rcptUpdRcptCompProperty.php' : '/api/org/receptures/rcptAddRcptCompProperty.php'
      const payload = { ...this.localProperty }
      payload.PROP_KOEFF = this.localProperty.PROP_KOEFF || 1
      payload.ULF_ID = this.component[0].ULF_ID
      payload.COMP_ID = this.component[0].COMP_ID
      axios({
        url: processorPath,
        method: 'POST',
        data: payload
      })
        .then(resp => {
          if (resp.data.error === 'ok') {
            if (action === 'add') {
              self.$emit('propertyAdded', resp.data.data)
            } else {
              self.$emit('propertyUpdate', resp.data.data)
            }
          } else {
            self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка: \n ${resp.data.error_text}` })
          }
        })
        .catch((err) => {
          self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка: \n ${err}` })
        })
    },
    doClear () {
    },
    doClose () {
      this.doClear()
      this.$emit('input', false)
    },
    doPropUpdate (data) {
      console.log('prjAddComponentPropertyDialog:: doPropUpdate method called ', data)
      this.localProperty = { ...this.localProperty, ...data }
      console.log('prjAddComponentPropertyDialog:: doPropUpdate current data is ', this.localProperty)
    }
  },
  mounted () {
    console.log('prjAddComponentPropertyDialog mounted with property ', this.property)
  }
}
</script>
